import { render, staticRenderFns } from "./FixedDepartureList.vue?vue&type=template&id=5e3f880c"
import script from "./FixedDepartureList.vue?vue&type=script&lang=js"
export * from "./FixedDepartureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports